import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ShowIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.02709 11.9996C4.5711 14.1298 6.82561 17.9996 12 17.9996C17.1744 17.9996 19.4289 14.1298 19.9729 11.9996C19.4289 9.86948 17.1744 5.99963 12 5.99963C6.82561 5.99963 4.5711 9.86949 4.02709 11.9996ZM2.0222 11.7901C2.57776 9.19747 5.34904 3.99963 12 3.99963C18.651 3.99963 21.4222 9.19747 21.9778 11.7901C22.0074 11.9282 22.0074 12.071 21.9778 12.2092C21.4222 14.8018 18.651 19.9996 12 19.9996C5.34904 19.9996 2.57776 14.8018 2.0222 12.2092C1.9926 12.071 1.9926 11.9282 2.0222 11.7901ZM12 9.99963C10.8954 9.99963 10 10.8951 10 11.9996C10 13.1042 10.8954 13.9996 12 13.9996C13.1046 13.9996 14 13.1042 14 11.9996C14 10.8951 13.1046 9.99963 12 9.99963ZM8 11.9996C8 9.79049 9.79086 7.99963 12 7.99963C14.2091 7.99963 16 9.79049 16 11.9996C16 14.2088 14.2091 15.9996 12 15.9996C9.79086 15.9996 8 14.2088 8 11.9996Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ShowIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ShowIcon);
